module.exports = __webpack_public_path__ + "img/predictive_header.8ed81713.jpg";